import React, { useState } from 'react';
import {
  Box,
  Paper,
  Typography,
  TextField,
  Button,
  IconButton,
  InputAdornment,
} from '@mui/material';
import LockIcon from '@mui/icons-material/Lock';
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import { verifyAdmin, setAdminToken, getAdminToken, clearAdminToken } from '../services/api';

const AdminGate = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(Boolean(getAdminToken()));
  const [accessCode, setAccessCode] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [authError, setAuthError] = useState(false);
  const [verifying, setVerifying] = useState(false);

  const handleSubmit = async () => {
    if (!accessCode) {
      setAuthError(true);
      return;
    }
    setVerifying(true);
    try {
      await verifyAdmin(accessCode);
      setAdminToken(accessCode);
      setIsAuthenticated(true);
      setAuthError(false);
      setAccessCode('');
    } catch (err) {
      clearAdminToken();
      setAuthError(true);
    } finally {
      setVerifying(false);
    }
  };

  if (isAuthenticated) {
    return typeof children === 'function' ? children({ logout: () => { clearAdminToken(); setIsAuthenticated(false); } }) : children;
  }

  return (
    <Box
      sx={{
        minHeight: 'calc(100vh - 48px)',
        backgroundColor: '#f4f4f4',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <Paper
        sx={{
          p: 4,
          maxWidth: 400,
          width: '100%',
          borderRadius: '16px',
          textAlign: 'center',
        }}
      >
        <Box
          sx={{
            width: 60,
            height: 60,
            borderRadius: '50%',
            backgroundColor: '#0f62fe15',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            mx: 'auto',
            mb: 2,
          }}
        >
          <LockIcon sx={{ fontSize: 28, color: '#0f62fe' }} />
        </Box>
        <Typography variant="h6" sx={{ fontWeight: 600, mb: 0.5 }}>
          Acceso Restringido
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
          Ingresa el código de acceso para continuar
        </Typography>
        <TextField
          fullWidth
          type={showPassword ? 'text' : 'password'}
          placeholder="Código de administrador"
          value={accessCode}
          onChange={(e) => {
            setAccessCode(e.target.value);
            setAuthError(false);
          }}
          onKeyPress={(e) => e.key === 'Enter' && handleSubmit()}
          error={authError}
          helperText={authError ? 'Código incorrecto' : ''}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <IconButton
                  onClick={() => setShowPassword(!showPassword)}
                  edge="end"
                  size="small"
                >
                  {showPassword ? <VisibilityOffIcon /> : <VisibilityIcon />}
                </IconButton>
              </InputAdornment>
            ),
          }}
          sx={{
            mb: 2,
            '& .MuiOutlinedInput-root': { borderRadius: '8px' },
          }}
        />
        <Button
          fullWidth
          variant="contained"
          onClick={handleSubmit}
          disabled={!accessCode || verifying}
          sx={{
            backgroundColor: '#0f62fe',
            borderRadius: '8px',
            py: 1.2,
            textTransform: 'none',
            fontWeight: 500,
            '&:hover': { backgroundColor: '#0043ce' },
          }}
        >
          Ingresar
        </Button>
      </Paper>
    </Box>
  );
};

export default AdminGate;
